// BCP (Business Continuity Partner) fax numbers for Nymbl integration
// These numbers have special handling for EMR uploads and AI extraction
// Keep in sync with backend BCP_NUMBERS in config/initializers/emr_fax_numbers.rb
export const BCP_NUMBERS = [
  '+13147433575', // Premier Prosthetics Saint Louis
  '+13342802853', // AALOS - Montgomery
  '+13345262755', // AALOS - Selma
  '+13347373014', // AALOS - Opelika
  '+13347946741', // AALOS - Dothan
  '+12054987404', // AALOS - Birmingham
  '+12516501561', // AALOS - Mobile
  '+12562601187', // AALOS - Priceville
  '+12706295532', // Bulow - Glasgow
  '+14233783363', // Victory - Kingsport
  '+14233985553', // Victory - Kingsport
  '+14234613314', // Victory - Johnson City
  '+15407670010', // VPO - Roanoke
  '+16064510078', // Bulow - Somerset
  '+16065061251', // Bulow - Pikeville
  '+16157127264', // Bulow - Nashville
  '+18037693611', // Bulow - Columbia
  '+18039265521', // Bulow - West Columbia
  '+18652498674', // Victory - Knoxville
  '+18664683883', // AALOS - Gulfport
  '+19102191456', // Beacon - Jacksonville
  '+14342202428', // VPO - Charlottesville
  '+15403811503', // VPO - Christiansburg
  '+14345090776', // VPO - Lynchburg
  '+15409494228', // VPO - Fishersville
  '+15404335447', // VPO - Harrisonburg
  '+12766345691', // VPO - Martinsville
  '+18044641301', // VPO - Richmond
];

export default BCP_NUMBERS;
